import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../../../chip/ChipRenderer.js";
import { ChipVariant, ChipType } from "../../../chip/types.js";
import { ChipWithTooltip } from "../../../chip/Chips.js";
import "../../../chip/ListWithChipTooltip.js";
import "../../../chip/SquaredChipList.js";
import "../../../icons/Icon.js";
import "../../../icons/ExpandMoreIcon.js";
import { withEmptyCheck } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
const useClasses = makeStyles()((theme) => ({
  textListWithTooltipCellVisibleElement: {
    flexShrink: 2,
    flexGrow: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: theme.spacing(0.5)
  },
  textListWithTooltipCellDropdownContent: {
    display: "grid",
    gridGap: theme.spacing(1),
    justifyItems: "baseline",
    flexShrink: 0,
    flexGrow: 0
  }
}));
function TextListWithTooltipCell({ visible, hidden }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.textListWithTooltipCellVisibleElement }, visible), hidden?.length ? /* @__PURE__ */ React.createElement(
    ChipWithTooltip,
    {
      chipType: ChipType.Status,
      chipVariant: ChipVariant.Grey,
      label: hidden?.length,
      fillWidth: false,
      title: /* @__PURE__ */ React.createElement(Box, { className: classes.textListWithTooltipCellDropdownContent }, hidden.map((item) => /* @__PURE__ */ React.createElement("div", null, item))),
      hideTooltip: false
    }
  ) : null);
}
const TextListWithTooltipCellAdapter = withEmptyCheck(({ value }) => {
  return /* @__PURE__ */ React.createElement(TextListWithTooltipCell, { visible: value?.[0], hidden: value });
});
const renderTextListWithTooltipCell = (params) => {
  const value = params.value;
  return /* @__PURE__ */ React.createElement(TextListWithTooltipCellAdapter, { value });
};
export {
  TextListWithTooltipCell,
  TextListWithTooltipCellAdapter,
  renderTextListWithTooltipCell
};
//# sourceMappingURL=TextListWithTooltipCell.js.map
